var parent = require('../../es/number');

module.exports = parent;

require('../../modules/esnext.number.from-string');



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/features/number/index.js
// module id = 1039
// module chunks = 1